import { Tag, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

/**
 * ⚠️ ADMIN PANELIDAGI `shared/ui/StatusTag.tsx` NING QISQARTIRILGAN
 * NUSXASI — ataylab.
 *
 * U yerda uchta komponent bor: abonent holati, ulanish holati va
 * `OperationResult` tegi. Oxirgi ikkitasi sheriklar kabinetida hech
 * qachon chizilmaydi (jonli sessiya ro'yxati ham, audit jurnali ham
 * yo'q), lekin nusxa to'liq ko'chirilsa ular bilan birga
 * `audit.status.*` va `status.online` tarjima kalitlari ham kelardi —
 * ya'ni uch tilda hech qachon ko'rinmaydigan matnlar. Kerak bo'lganda
 * o'sha fayldan qo'shiladi.
 */
export type SubscriberState = 'NEW' | 'ACTIVE' | 'SUSPENDED' | 'BLOCKED' | 'CLOSED'

/**
 * Rang holatning SABABINI ko'rsatadi, og'irligini emas:
 *   · `SUSPENDED` — sariq, chunki bu TIZIM qarori (pul tugadi) va
 *     to'lovdan keyin o'zi tiklanadi
 *   · `BLOCKED` — qizil, chunki bu ODAM qarori va faqat odam ochadi
 * Ikkalasini bitta rangda ko'rsatish kassirga NOTO'G'RI ish aytardi:
 * birinchisida balansni to'ldirish yetadi, ikkinchisida esa pul
 * qo'yish abonentni ulamaydi.
 */
const STATE_COLOR: Record<SubscriberState, string> = {
  NEW: 'default',
  ACTIVE: 'green',
  SUSPENDED: 'gold',
  BLOCKED: 'red',
  CLOSED: 'default',
}

const STATE_HINT: Partial<Record<SubscriberState, string>> = {
  SUSPENDED: 'subscriberState.suspendedHint',
  BLOCKED: 'subscriberState.blockedHint',
}

export function SubscriberStateTag({ state }: { state: SubscriberState }) {
  const { t } = useTranslation()
  const hintKey = STATE_HINT[state]
  const tag = <Tag color={STATE_COLOR[state]}>{t(`subscriberState.${state}`)}</Tag>

  return hintKey ? <Tooltip title={t(hintKey)}>{tag}</Tooltip> : tag
}
